import {
  MAX_MISE_DE_FONDS_PERCENTAGE,
  MIN_MISE_DE_FONDS_PERCENTAGE,
  MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME,
  MISE_DE_FONDS_DEUXIEME_PALIER_PERCENTAGE,
  MISE_DE_FONDS_PREMIER_PALIER_MONTANT,
  MISE_DE_FONDS_PREMIER_PALIER_PERCENTAGE
} from '../../../../shared/modeles/variables';

export class MiseDeFondsHelper {
  private static readonly PERCENTAGE_PRECISION = 0.01;

  static calculateMiseDeFondsAmountFromPercentage(rawPercentage: any, montantPropriete: number): number {
    const miseDeFondsPercentage = this.cleanPercentageValue(rawPercentage);
    return Math.ceil((miseDeFondsPercentage / 100) * montantPropriete);
  }

  static calculateMiseDeFondsPercentageFromAmount(miseDeFondsAmount: number, montantPropriete: number): number {
    let percentageResult = 0;
    if (miseDeFondsAmount && montantPropriete) {
      const rawPercentage = (miseDeFondsAmount / montantPropriete) * 100;
      percentageResult = this.cleanPercentageValue(rawPercentage);
    }
    return percentageResult;
  }

  static cleanPercentageValue(rawPercentage: any): number {
    let cleanedPercentage = 0;
    rawPercentage = Number(rawPercentage);
    if (!isNaN(rawPercentage)) {
      // Don't round up when the percentage is near 5% or 20%
      // to prevent misleading SCHL premium message
      if (
        rawPercentage >= MIN_MISE_DE_FONDS_PERCENTAGE - this.PERCENTAGE_PRECISION &&
        rawPercentage < MIN_MISE_DE_FONDS_PERCENTAGE
      ) {
        cleanedPercentage = MIN_MISE_DE_FONDS_PERCENTAGE - this.PERCENTAGE_PRECISION;
      } else if (
        rawPercentage >= MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME - this.PERCENTAGE_PRECISION &&
        rawPercentage < MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME
      ) {
        cleanedPercentage = MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME - this.PERCENTAGE_PRECISION;
      } else {
        cleanedPercentage =
          Math.round(rawPercentage) !== rawPercentage ? Number(rawPercentage.toFixed(2)) : rawPercentage;
      }
    }
    return cleanedPercentage;
  }

  static isMiseDeFondsValide(miseDeFondsAmount: number, montantPropriete: any): boolean {
    return (
      miseDeFondsAmount >= (miseDeFondsAmount * MIN_MISE_DE_FONDS_PERCENTAGE) / 100 &&
      miseDeFondsAmount <= (montantPropriete * MAX_MISE_DE_FONDS_PERCENTAGE) / 100
    );
  }

  static getMiseDeFondMinimale(montantPropriete: number): number {
    return (
      (Math.min(montantPropriete, MISE_DE_FONDS_PREMIER_PALIER_MONTANT) * MISE_DE_FONDS_PREMIER_PALIER_PERCENTAGE +
        Math.max(montantPropriete - MISE_DE_FONDS_PREMIER_PALIER_MONTANT, 0) *
          MISE_DE_FONDS_DEUXIEME_PALIER_PERCENTAGE) /
      100
    );
  }

  static getMiseDeFondMaximale(montantPropriete: number): number {
    return Math.ceil((montantPropriete * MAX_MISE_DE_FONDS_PERCENTAGE) / 100);
  }

  static getMiseDeFondMinimaleSansPrime(montantPropriete: number): number {
    return (montantPropriete * MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME) / 100;
  }

  static isPrimeSCHLApplicable(miseDeFondsAmount: number, montantPropriete: number): boolean {
    return miseDeFondsAmount < (montantPropriete * MIN_MISE_DE_FONDS_PERCENTAGE_SANS_PRIME) / 100;
  }

  static isMiseDeFondsSuffisante(miseDeFondsAmount: number, montantPropriete: number): boolean {
    return miseDeFondsAmount >= this.getMiseDeFondMinimale(montantPropriete);
  }
}
